module.exports = __webpack_public_path__ + "static/media/Maintainance2.da549c0f.svg";